import {DataTableTranslations} from'./data-table-translations.type'

export const defaultTranslations: DataTableTranslations = {
  indexColumn: 'index',
  selectColumn: 'select',
  expandColumn: 'expand',
  paginationLimit: 'Limit',
  paginationRange: 'Results'
};
